// 3rd party imports
import * as React from 'react';

// bernie
import { withLocalization, LocalizedText } from 'bernie-l10n';

// ui
import { UitkHeading, UitkText } from 'uitk-react-text';

// components
import { AffiliateCTA } from '../affiliate-cta';
import { LocalizedComponentProps } from '@shared-ui/localization-context';

export interface OutroProps extends LocalizedComponentProps {
  locale?: string;
}

@withLocalization
export class Outro extends React.Component<OutroProps> {
  public render() {
    return (
      <UitkText align="center">
        <UitkHeading tag="h2" size={2}>
          <LocalizedText message="home.outro.heading.start_earning_today" />
        </UitkHeading>
        <UitkText spacing="six">
          <LocalizedText message="home.outro.content.create_an_account_now" />
        </UitkText>
        <UitkText spacing="six">
          <AffiliateCTA locale={this.props.locale} />
        </UitkText>
      </UitkText>
    );
  }
}
